export default __webpack_public_path__ + "static/generic-banner-2212f11c0b932d53e4acadd1df489db1.png";